import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { navigateTo } from 'gatsby-link'
import { Formik } from 'formik'
import { object as yupObject, string as yupString } from 'yup'
import boolean from 'boolean'

import { resetGame } from '../modules'
import { setIsOver18 } from '../modules/player'

import { media } from '../theme'
import ContentContainer from '../components/ContentContainer'
import DottedRule from '../components/DottedRule'
import Form from '../components/Form'
import FormErrorMessage from '../components/FormErrorMessage'
import FormRadio from '../components/FormRadio'
import FormSubmit from '../components/FormSubmit'
import Heading from '../components/Heading'

const OverhangingFormSubmit = styled(FormSubmit)`
  margin-top: ${(p) => p.theme.spacing(0)};

  ${media.greaterThan('medium')`
    bottom: 0;
    left: 50%;
    position: absolute;
    transform: translate(-50%, 50%);
  `};
`

const StyledForm = styled(Form)`
  margin: ${(p) => p.theme.spacing(0)} auto ${(p) => p.theme.spacing(2)};
  width: auto;
`

const RadioContainer = styled.div`
  display: flex;
  flex-direction: column;

  ${media.greaterThan('medium')`
    flex-direction: row;
  `};
`

const StyledFormRadio = styled(FormRadio)`
  flex: 1 1 auto;
  margin-bottom: ${(p) => p.theme.spacing(-1)};

  ${media.greaterThan('medium')`
    margin-bottom: 0;
    margin-right: ${(p) => p.theme.spacing(2)};

    &:last-child {
      margin-right: 0;
    }
  `};
`

class AgePage extends Component {
  constructor() {
    super()

    this.handleSubmit = this.handleSubmit.bind(this)
  }

  handleSubmit({ isOver18 }, { setSubmitting }) {
    const { resetGame, setIsOver18 } = this.props

    resetGame()
    setIsOver18(boolean(isOver18))
    setSubmitting(false)

    navigateTo('/player/')
  }

  render() {
    const { isOver18 } = this.props

    return (
      <ContentContainer>
        <Heading level={2} last={true}>
          Let's get to know you
        </Heading>
        <DottedRule />
        <Heading level={3}>How old are you?</Heading>
        <Formik
          validationSchema={yupObject().shape({
            isOver18: yupString()
              .nullable()
              .required('Please select an option'),
          })}
          initialValues={{ isOver18: null }}
          onSubmit={this.handleSubmit}
        >
          {({ values }) => (
            <StyledForm>
              <div>
                <RadioContainer>
                  <StyledFormRadio
                    name="isOver18"
                    value={false}
                    label="I'm under 18"
                  />
                  <StyledFormRadio
                    name="isOver18"
                    value={true}
                    label="I'm 18 or older"
                  />
                </RadioContainer>
                <FormErrorMessage name="isOver18" textAlign="center" />
              </div>
              <OverhangingFormSubmit value="Next" />
            </StyledForm>
          )}
        </Formik>
      </ContentContainer>
    )
  }
}

const mapStateToProps = (state) => ({
  isOver18: state.player.isOver18,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ resetGame, setIsOver18 }, dispatch)

const AgePageConnected = connect(mapStateToProps, mapDispatchToProps)(AgePage)

export default AgePageConnected



// WEBPACK FOOTER //
// ./src/pages/age.js